export default "__VITE_ASSET__CwH1LUQO__"